<div [hidden]="!showPanel">
  <div class="panel panel-border-primary">
    @if (!groupStudentFullName) {
      <h5 class="panel-title">
        Progress Report - {{action}}
      </h5>
    }
    @if (groupStudentFullName) {
      <h5 class="panel-title">
        Progress Report for {{groupStudentFullName}} - {{action}}
      </h5>
    }
    <div class="panel-tooltip">
      {{headerSubText}}
    </div>
    <div id="collapse1" class="panel-collapse" [class.tw:hidden]='current != 1'>
      <form [formGroup]="frmStudentOutcomes">

        <div class="flex-row">

          <div class="flex-column">
            <label>Date of update</label>
            <input type="date" class="field__control" id="outcomeDate" required formControlName="outcomeDate">
            @if ((frmStudentOutcomes.controls.outcomeDate.touched || formSavedSubmitted)
              && !frmStudentOutcomes.controls.outcomeDate.hasError('DateCannotBeEarlierThanBaselineDate')
              && frmStudentOutcomes.controls.outcomeDate.errors) {
              <span class="field__error font-12 tw:mt-0">Date should be between {{ mindate | date : 'dd/MM/yyyy'}} and {{maxdate | date : 'dd/MM/yyyy'}}</span>
            }
            @if ((frmStudentOutcomes.controls.outcomeDate.touched || formSavedSubmitted) && frmStudentOutcomes.controls.outcomeDate.hasError('DateCannotBeEarlierThanBaselineDate')) {
              <span class="field__error font-12 tw:mt-0">{{baselineDateError}}</span>
            }
          </div>

          <div class="flex-column">
            <div class="form-group">
              <label>Assessment score %</label>
              <div class="tw:flex tw:items-center">
                <input type="number" class="field__control" formControlName="assessmentScorePercentage" (keydown)="parseAssessmentScore($event)"
                  min="0" max="100" />
              </div>
              @if (frmStudentOutcomes.controls.assessmentScorePercentage.errors && (frmStudentOutcomes.controls.assessmentScorePercentage.errors.min || frmStudentOutcomes.controls.assessmentScorePercentage.errors.max)) {
                <span class="field__error">Assessment score percentage can only be between 0 and 100.</span>
              }
            </div>
          </div>

        </div>

        <div class="flex-row">
          <div class="flex-column">
            <label>Key Stage</label>
            @if (! media.isActive('xs')) {
              <select class="field__control" formControlName="keyStage">
                @for (stage of keyStages; track stage) {
                  <option [ngValue]="stage.id">{{stage.description}}</option>
                }
              </select>
            }
            @if (media.isActive('xs')) {
              <input class="field__control" formControlName="keyStage" placeholder="Select Current Key Stage" type="text"
                (click)="openDropdownDialog(keyStages, 'keyStage', 'Current Key Stage', frmStudentOutcomes.value.keyStage, false);"
                readonly />
            }
          </div>

          <div class="flex-column">
            <label>Learning Band</label>
            @if (! media.isActive('xs')) {
              <select class="field__control" formControlName="learningBand">
                @for (grade of grades; track grade) {
                  <option [ngValue]="grade.id">{{grade.code}}&nbsp;&nbsp;{{grade.description}}</option>
                }
              </select>
            }
            @if (media.isActive('xs')) {
              <input class="field__control" formControlName="learningBand" placeholder="Select Learning Band" type="text"
                (click)="openDropdownDialog(grades, 'learningBand', 'Current Learning Band', frmStudentOutcomes.value.learningBand, true);"
                readonly />
            }
            </div>
          </div>
          <div class="form-group">
            <label>Progress towards Target</label>
            <textarea class="field__control" stringFormatter #progressTarget cdkTextareaAutosize cdkAutosizeMinRows="1"
              formControlName="comments" cdkAutosizeMaxRows="5"></textarea>
            <span class="field__hint tw:block tw:text-right">{{progressTarget.value?.length || 0}}/1024</span>
            @if (frmStudentOutcomes.controls.comments.invalid && frmStudentOutcomes.controls.comments.touched) {
              <span class="field__error">Comments, should not exceed 1024 characters.</span>
            }
          </div>
          <div class="form-group">
            <label>Target for next period </label>
            <textarea class="field__control" #targetNextPeriod cdkTextareaAutosize cdkAutosizeMinRows="1" formControlName="target"
              cdkAutosizeMaxRows="5"></textarea>
            <span class="field__hint tw:block tw:text-right">{{targetNextPeriod.value?.length || 0}}/1024</span>
            @if (frmStudentOutcomes.controls.target.invalid && frmStudentOutcomes.controls.target.touched) {
              <span class="field__error">Target for next period, should not exceed 1024 characters.</span>
            }
          </div>
          <div class="form-group">
            <label>{{themeService.siteContent.learnerPupilLabel}} comments</label>
            <textarea class="field__control" stringFormatter #learnerComments cdkTextareaAutosize cdkAutosizeMinRows="1"
              formControlName="learnerComments" cdkAutosizeMaxRows="5"></textarea>
            <span class="field__hint tw:block tw:text-right">{{learnerComments.value?.length || 0}}/1024</span>
            @if (frmStudentOutcomes.controls.learnerComments.invalid && frmStudentOutcomes.controls.learnerComments.touched) {
              <span class="field__error">{{themeService.siteContent.learnerPupilLabel}} comments, should not exceed 1024 characters.</span>
            }
          </div>
          @if (submissionData) {
            <div class="form-group">
              <div class="submission-history"><a (click)="openDialog();">View History</a></div>
            </div>
          }
          <div class="div-flex-buttons">
            <div class="div-flex-buttons">
              @if (hasStaffSavePermissions && !hasManagerSavePermissions) {
                <div class="div-flex-buttons">
                  <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="SaveDraft" value="Save" (click)="saveOutcome()" [disabled]="model.submitted || model.approved || loading">Save</button></div>
                  <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="Submit" value="Submit" (click)="submitOutcome()" [disabled]="model.submitted || model.approved || loading">Submit</button></div>
                </div>
              }
              @if (hasManagerSavePermissions) {
                <div class="div-padding-right-10 div-flex-buttons">
                  <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="SaveDraft" value="Save" (click)="saveOutcome()" [disabled]="model.approved || loading">Save</button></div>
                  <div class="div-padding-right-10"><button type="submit" class="btn btn-primary" name="Submit" value="Submit" (click)="submitOutcome()" [disabled]="model.approved || loading">Submit</button></div>
                </div>
              }
              <div class="div-padding-right-10 div-flex-buttons">
                @if (model.submitted && !model.approved) {
                  <report-controls (onApproved)="approveData($event)" (onRejected)="rejectData($event)"
                    [approved]="model.approved || loading" [canApprove]="hasApprovePermissions" [canReject]="hasRejectPermissions"
                  ></report-controls>
                }
              </div>
            </div>
            <div class="div-flex-buttons tw:float-right">

              <div class="div-padding-right-10"><button type="button" class="btn btn-primary" id="RefTable" style="width: 115px;" name="RefTable" value="RefTable" (click)="openReferenceTable()">Grading Table</button></div>

              <div class="div-padding-right-10"><button type="button" class="btn btn-primary" id="Close" name="Close" value="Close" (click)="close()">Close</button></div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>